import {
  Pressable,
  Image,
  ImageBackground,
  Text,
  View,
} from 'react-native'
import useDimension from '../../hooks/use-dimension'
import ModalWrapper from '../../components/modal/ModalWrapper'
import { imgIntro } from '../../data/images'
const { bgModal, btnAgain, btnYes } = imgIntro

type Props = {
  showModal: boolean
  onYes: () => void
  onClose: () => void
  txt: JSX.Element | string
  imgs?: { bgImg: string; btnImg: string; btnYes: string }
}

export default function SelectRoleModal({
  showModal,
  onYes,
  onClose,
  txt,
  imgs = { bgImg: bgModal, btnImg: btnAgain, btnYes: btnYes },
}: Props) {
  const { ws } = useDimension()

  // const { bgImg, btnImg } = imgs

  return (
    <ModalWrapper
      isOpen={showModal}
      onClose={onClose}
      bgImg={''}
      styleProps={{ modalTp: 0, bgW: 360, bgH: 640 }}
      BgColor={'#fff6'}
    >
      <ImageBackground
        source={{ uri: imgs.bgImg }}
        style={{
          position: 'relative',
          alignItems: 'center',
          justifyContent: 'center',
          width: 345 * ws,
          height: 228.6 * ws,
          paddingInline: 15 * ws,
          marginTop: 228.5 * ws,
        }}
        resizeMode="contain"
        aria-label={`bg-wrong`}
      >
        <Text
          style={{
            marginTop: 25 * ws,
            fontSize: 15.5 * ws,
            fontWeight: 'normal',
            lineHeight: 23.5,
            letterSpacing: 0,
            textAlign: 'center',
            color: '#85253f',
            fontFamily: 'love',
          }}
        >
          {txt}
        </Text>
        <View style={{ flexDirection: 'row', gap: 27.5 * ws }}>
          <Pressable
            style={({ pressed }) => [
              { opacity: pressed ? 0.5 : 1.0, marginTop: 20 * ws },
            ]}
            onPress={onYes}
          >
            <Image
              source={{ uri: imgs.btnYes }}
              style={{
                width: 76.5 * ws,
                height: 40 * ws,
              }}
              resizeMode="contain"
              aria-label={`btn-close`}
            />
          </Pressable>

          <Pressable
            style={({ pressed }) => [
              { opacity: pressed ? 0.5 : 1.0, marginTop: 20 * ws },
            ]}
            onPress={onClose}
          >
            <Image
              source={{ uri: imgs.btnImg }}
              style={{
                width: 99 * ws,
                height: 40 * ws,
              }}
              resizeMode="contain"
              aria-label={`btn-close`}
            />
          </Pressable>
        </View>
      </ImageBackground>
    </ModalWrapper>
  )
}
